<script lang="ts" setup>
import AlternateMarquee from '@/home/components/AlternateMarquee.vue';
</script>

<template>
  <section class="page-home-information pb-100">
    <div class="mx-auto max-w-1200 flex flex-nowrap gap-x-95">
      <div class="w-540 flex-shrink-0 pt-112">
        <h2 class="my-0 text-nowrap text-46 text-#292D33 font-800 leading-60">
          {{ $t('home.information.content1.title1') }}
          <AlternateMarquee>{{ $t('home.information.content1.title2') }}</AlternateMarquee>
        </h2>

        <p class="mb-0 mt-30 text-20 text-#9497A1 font-400 leading-1.5em">
          {{ $t('home.information.content1.desc') }}
        </p>

        <div class="mt-30 flex justify-between">
          <RouterLink to="/cooperation" class="h-54 w-190 flex-center rounded-6 bg-#1281FF text-16 text-white font-700 leading-24 no-underline shadow-[0px_12px_30px_rgba(24,92,255,0.18)]">
            {{ $t('home.information.content1.button') }}
          </RouterLink>
        </div>
      </div>

      <div>
        <img data-src="@/home/assets/home/banner2.png" alt="" class="lazyload block h-590">
      </div>
    </div>

    <div class="mx-auto mt-60 max-w-1602 flex flex-nowrap gap-x-95">
      <div>
        <img data-src="@/home/assets/home/banner3.png" alt="" class="lazyload block h-590">
      </div>

      <div class="w-540 flex-shrink-0 pt-112">
        <h2 class="my-0 text-nowrap text-46 text-#292D33 font-800 leading-60">
          {{ $t('home.information.content2.title1') }}
          <AlternateMarquee>{{ $t('home.information.content2.title2') }}</AlternateMarquee>
        </h2>

        <p class="mb-0 mt-30 text-20 text-#9497A1 font-400 leading-1.5em">
          {{ $t('home.information.content2.desc') }}
        </p>

        <div class="mt-30 flex justify-between">
          <RouterLink to="/projects" class="h-54 w-190 flex-center rounded-6 bg-#1281FF text-16 text-white font-700 leading-24 no-underline shadow-[0px_12px_30px_rgba(24,92,255,0.18)]">
            {{ $t('home.information.content2.button') }}
          </RouterLink>
        </div>
      </div>
    </div>

    <div class="mx-auto mt-60 max-w-1200 flex flex-nowrap gap-x-95">
      <div class="w-540 flex-shrink-0 pt-112">
        <h2 class="my-0 text-nowrap text-46 text-#292D33 font-800 leading-60">
          {{ $t('home.information.content3.title1') }}
          <AlternateMarquee>{{ $t('home.information.content3.title2') }}</AlternateMarquee>
        </h2>

        <p class="mb-0 mt-30 text-20 text-#9497A1 font-400 leading-1.5em">
          {{ $t('home.information.content3.desc') }}
        </p>

        <div class="mt-30 flex justify-between">
          <a href="https://community.openatom.cn/" class="h-54 w-190 flex-center rounded-6 bg-#1281FF text-16 text-white font-700 leading-24 no-underline shadow-[0px_12px_30px_rgba(24,92,255,0.18)]" target="_blank">
            {{ $t('home.information.content3.button') }}
          </a>
        </div>
      </div>

      <div>
        <img data-src="@/home/assets/home/banner4.png" alt="" class="lazyload block h-470">
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
</style>
